import { render, staticRenderFns } from "./dcdcDetail.vue?vue&type=template&id=5940cc14&scoped=true"
import script from "./dcdcDetail.vue?vue&type=script&lang=js"
export * from "./dcdcDetail.vue?vue&type=script&lang=js"
import style0 from "./dcdcDetail.vue?vue&type=style&index=0&id=5940cc14&prod&lang=scss&scoped=true"
import style1 from "./dcdcDetail.vue?vue&type=style&index=1&id=5940cc14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940cc14",
  null
  
)

export default component.exports